@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/spacing";

web-chatbot-input {
    .input {
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: spacing.$md;
        margin-bottom: spacing.$xl;
        min-height: 4rem;
        width: 100%;
    }
    .input-container {
        flex: 1 0 auto;
        margin: 0 spacing.$md 0 0;
        position: relative;
        input {
            width: 100%;
            padding-right: 1.4rem;
        }
    }

    web-button button {
        padding: 0;
        height: 5rem;
        span {
            display: none;
        }
    }

    .input-max-length {
        position: absolute;
        right: 0;
        color: color.$color-text-lighter;
        font-size: font-size.$xxxs;
        .warning {
            font-weight: bold;
            color: color.$color-primary;
        }
    }

    @media screen and (max-width: breakpoints.$screen-sm-max) {
        .button.button-large {
            --spacing-padding-inline: 1.6rem;
        }
    }

    @media (min-width: breakpoints.$screen-md-min) {
        .input {
            padding: 0 spacing.$xxxl;
        }

        .input-max-length {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: spacing.$md;
            font-size: font-size.$xs;
        }

        .input-container {
            input {
                padding: 0.8rem 11.4rem 0.8rem 1.4rem;
            }
        }

        web-button button span {
            display: block;
        }
    }
}

[slot="footer"] {
    @media (min-width: breakpoints.$screen-md-min) {
        --left-gutter: 90px;
        padding-left: var(--left-gutter);
    }
}
